import {
  Control,
  Controller,
  FieldErrors,
  FieldPath,
  FieldValues,
  RegisterOptions,
} from 'react-hook-form';
import TextInput from '@havenengineering/module-shared-library/dist/form/components/TextInput';

type ControlledTextInputProps<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
> = {
  id: TName;
  label: string;
  control: Control<TFieldValues>;
  rules?: Omit<
    RegisterOptions<TFieldValues, TName>,
    'valueAsNumber' | 'valueAsDate' | 'setValueAs' | 'disabled'
  >;
  errors?: FieldErrors<TFieldValues>;
  className?: string;
  type?: 'text' | 'email' | 'password';
};

export const ControlledTextInput = <
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
>({
  id,
  label,
  control,
  rules = {},
  errors,
  className,
  type = 'text',
}: ControlledTextInputProps<TFieldValues, TName>) => {
  return (
    <Controller
      name={id}
      control={control}
      rules={rules}
      render={({ field }) => (
        <TextInput
          id={id}
          label={label}
          {...field}
          error={errors?.[id]?.message?.toString()}
          className={className}
          type={type}
        />
      )}
    />
  );
};
